import React from 'react';

import { Box, xcss } from '@atlaskit/primitives';

import { fg } from '@confluence/feature-gating';

import { EmojiPlaceholder } from '../EmojiPlaceholder';

export type EmojiTitleSelectionPlaceholderProps = {
	hasInitialEmoji?: boolean;
	hasCoverPicture?: boolean;
	isTitleCenterAligned?: boolean;
};

const paddingStyle = xcss({
	paddingRight: 'space.200',
});

export const EmojiTitleSelectionPlaceholder = ({
	hasInitialEmoji,
	hasCoverPicture,
	isTitleCenterAligned,
}: EmojiTitleSelectionPlaceholderProps) => {
	const needsPadding = !hasCoverPicture && !isTitleCenterAligned;

	return hasInitialEmoji && fg('confluence_perf_title_emoji_load_livepage') ? (
		<Box xcss={needsPadding ? paddingStyle : null} testId="emoji-selection-placeholder-container">
			<EmojiPlaceholder height={hasCoverPicture ? 80 : 40} />
		</Box>
	) : null;
};
